import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import TableDataLayerVolunteers from "../components/TableDataLayerVolunteers";

const TableDataPageVolunteers = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
          <Breadcrumb title="Volunteers List" tooltipContent="Add New DCFs" linkTo="/dfo-form"  requiredPermission={{ module: 'dfo_list', action: 'create' }} />
    
        {/* TableDataLayerDfos */}
        <TableDataLayerVolunteers  />

      </MasterLayout>

    </>
  );
};

export default TableDataPageVolunteers; 
